import { useQuery, useQueryClient } from '@tanstack/react-query';
import { DrawApi } from '@apply/api';
import { IDrawBudget } from '@apply/api/src/api/DrawApi';
import { applicationInsights } from '../ApplicationInsights';

const drawApi = new DrawApi.DrawApi(applicationInsights);

export enum DrawQueryKeys {
    DrawBudget = 'drawBudget',
}

export function drawBudgetQueryKey(drawBudgetId: number) {
    return [DrawQueryKeys.DrawBudget, drawBudgetId] as const;
}

export function useDrawBudgetQuery(drawBudgetId: number | undefined) {
    return useQuery({
        queryKey: drawBudgetQueryKey(drawBudgetId ?? 0),
        queryFn: async (): Promise<IDrawBudget> => {
            const response = await drawApi.getDrawBudget(drawBudgetId!);
            if (response.statusCode !== 200) {
                throw new Error('Get Draw Budget call failed.');
            }
            return response.result;
        },
        enabled: !!drawBudgetId,
    });
}

export function useInvalidateDrawBudget() {
    const queryClient = useQueryClient();
    return (drawBudgetId: number) => {
        queryClient.invalidateQueries({ queryKey: drawBudgetQueryKey(drawBudgetId) });
    };
}
